module.exports = __webpack_public_path__ + "media/images/pic/teachers/marta-szulc-87b23fdfdfbb0757cb2bdd38d4994086.webp";